document.addEventListener('DOMContentLoaded', function () {
  function formatEuro(cents) {
    return new Intl.NumberFormat('it-IT', {
      style: 'currency',
      currency: 'EUR'
    }).format(cents / 100);
  }

  function triggerGlow(fill) {
    if (!fill) return;
    fill.classList.remove('is-glow');
    void fill.offsetWidth;
    fill.classList.add('is-glow');
    setTimeout(function () {
      fill.classList.remove('is-glow');
    }, 350);
  }

  function triggerReward(bar) {
    if (!bar) return;
    bar.classList.remove('is-rewarding');
    void bar.offsetWidth;
    bar.classList.add('is-rewarding');
    setTimeout(function () {
      bar.classList.remove('is-rewarding');
    }, 1200);
  }

  function updateBarUI(bar, totalCents, threshold) {
    let progress = (totalCents / threshold) * 100;
    if (progress > 100) progress = 100;
    if (progress < 0) progress = 0;

    const remaining = threshold - totalCents;
    const message = bar.querySelector('.free-shipping-progress__message');
    const fill = bar.querySelector('.free-shipping-progress__fill');
    const count = bar.querySelector('.free-shipping-progress__count');
    const percent = bar.querySelector('.free-shipping-progress__percent');
    const wasSuccess = bar.classList.contains('is-success');

    if (fill) {
      const oldWidth = parseFloat(fill.style.width || '0');
      fill.style.width = progress + '%';
      if (progress > oldWidth) triggerGlow(fill);
    }

    if (count) {
      count.textContent = formatEuro(totalCents) + ' / ' + formatEuro(threshold);
    }

    if (percent) {
      percent.textContent = Math.round(progress) + '%';
    }

    if (message) {
      if (remaining > 0) {
        message.classList.remove('free-shipping-progress__message--success');
        bar.classList.remove('is-success');
        message.innerHTML =
          'Ti mancano <strong>' + formatEuro(remaining) + '</strong> per la spedizione gratuita';
      } else {
        message.classList.add('free-shipping-progress__message--success');
        bar.classList.add('is-success');
        message.innerHTML = '🎉 Complimenti! Hai sbloccato la spedizione gratuita';

        if (!wasSuccess) {
          triggerReward(bar);
        }
      }
    }
  }

  async function getCartTotalCents() {
    try {
      const response = await fetch('/cart.js', {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' }
      });

      const cart = await response.json();
      return parseInt(cart.total_price || 0, 10);
    } catch (error) {
      return null;
    }
  }

  async function updateProductFreeShippingBar(useLiveCart = false) {
    const bar = document.querySelector('[data-free-shipping][data-product-mode="true"]');
    if (!bar) return;

    const threshold = parseInt(bar.dataset.threshold || '0', 10);
    let cartTotal = parseInt(bar.dataset.cartTotal || '0', 10);

    if (useLiveCart) {
      const liveCartTotal = await getCartTotalCents();
      if (liveCartTotal !== null) {
        cartTotal = liveCartTotal;
        bar.dataset.cartTotal = String(liveCartTotal);
      }
    }

    updateBarUI(bar, cartTotal, threshold);
  }

  async function refreshDrawerFreeShippingBar() {
    const currentBar = document.querySelector('.drawer [data-free-shipping], .cart-drawer [data-free-shipping]');
    if (!currentBar) return;

    try {
      const response = await fetch('/?section_id=cart-drawer', {
        credentials: 'same-origin'
      });

      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const newBar = doc.querySelector('.drawer [data-free-shipping], .cart-drawer [data-free-shipping]');

      if (!newBar) return;

      const oldWasSuccess = currentBar.classList.contains('is-success');
      const newIsSuccess = newBar.classList.contains('is-success');

      currentBar.replaceWith(newBar);

      const insertedBar = document.querySelector('.drawer [data-free-shipping], .cart-drawer [data-free-shipping]');
      if (insertedBar && newIsSuccess && !oldWasSuccess) {
        triggerReward(insertedBar);
      }
    } catch (error) {
      console.error('Errore aggiornamento barra drawer:', error);
    }
  }

  function scheduleDrawerRefresh(delay) {
    setTimeout(function () {
      refreshDrawerFreeShippingBar();
    }, delay);
  }

  function scheduleProductRefresh(delay, useLiveCart = true) {
    setTimeout(function () {
      updateProductFreeShippingBar(useLiveCart);
    }, delay);
  }

  document.addEventListener('input', function (event) {
    if (
      event.target.matches('input[name="quantity"]') ||
      event.target.matches('.quantity__input')
    ) {
      updateProductFreeShippingBar(false);
    }
  });

  document.addEventListener('change', function (event) {
    if (
      event.target.matches('input[name="quantity"]') ||
      event.target.matches('.quantity__input')
    ) {
      updateProductFreeShippingBar(false);
      scheduleDrawerRefresh(700);
    }
  });

  document.addEventListener('click', function (event) {
    if (
      event.target.closest('button[name="plus"]') ||
      event.target.closest('button[name="minus"]')
    ) {
      setTimeout(function () {
        updateProductFreeShippingBar(false);
      }, 50);

      scheduleDrawerRefresh(800);
    }

    if (
      event.target.closest('cart-remove-button') ||
      event.target.closest('.cart-remove-button') ||
      event.target.closest('[name="remove"]')
    ) {
      scheduleDrawerRefresh(800);
      scheduleProductRefresh(900, true);
    }

    if (
      event.target.closest('button[name="add"]') ||
      event.target.closest('product-form button[type="submit"]') ||
      event.target.closest('form[action*="/cart/add"] button[type="submit"]')
    ) {
      scheduleDrawerRefresh(900);
      scheduleProductRefresh(1000, true);
    }
  });

  document.addEventListener('submit', function (event) {
    if (
      event.target.matches('form[action*="/cart/add"]') ||
      event.target.closest('product-form form')
    ) {
      scheduleDrawerRefresh(900);
      scheduleProductRefresh(1000, true);
    }
  });

  document.addEventListener('cart:refresh', function () {
    refreshDrawerFreeShippingBar();
    updateProductFreeShippingBar(true);
  });

  document.addEventListener('cart:updated', function () {
    refreshDrawerFreeShippingBar();
    updateProductFreeShippingBar(true);
  });

  updateProductFreeShippingBar(true);
  refreshDrawerFreeShippingBar();
});